import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { AlertCircle } from 'lucide-react'

import { api, ErrorApi } from '@/lib/api'
import { Modal } from '@/componentes/ui/Modal'

// Abrir el turno del cajón.
//
// Vive en su propio archivo y no dentro de la pantalla Turno porque lo abren
// TRES lugares: esa pantalla y las dos pantallas de venta, que ahora ofrecen
// el botón donde antes decían «está en Turno, en el menú de la izquierda».
// Importarlo desde la pantalla Turno obligaría al POS a arrastrar la pantalla
// entera.
//
// El pie va en el `pie` del Modal y no adentro del cuerpo, que es el gotcha
// que el sistema ya pagó cuatro veces: el Modal acota el alto y reparte por
// flex, así que el pie no scrollea nunca, y un botón armado en el cuerpo
// queda abajo del pliegue en un teléfono.

export function DialogoAbrirTurno({ onCerrar, onListo }: { onCerrar: () => void; onListo: () => void }) {
  const [pesos, setPesos] = useState('')
  const [error, setError] = useState<string | null>(null)

  const abrir = useMutation({
    mutationFn: () =>
      api.post('/turno/abrir', { fondoInicialCentavos: Math.round(Number(pesos || 0) * 100) }),

    onSuccess: () => {
      onListo()
      onCerrar()
    },

    onError: (e) =>
      setError(e instanceof ErrorApi ? e.message : 'No se pudo abrir el turno. Reintentá.'),
  })

  return (
    <Modal
      onCerrar={onCerrar}
      titulo="Abrir el turno"
      descripcion="El fondo inicial es la plata con la que arranca el cajón."
      ancho="sm"
      pie={
        <>
          <button type="button" onClick={onCerrar} className="btn-secundario flex-1">
            Cancelar
          </button>

          <button
            type="button"
            onClick={() => abrir.mutate()}
            disabled={abrir.isPending || pesos === ''}
            className="btn-primario flex-1"
          >
            {abrir.isPending ? 'Abriendo…' : 'Abrir'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div>
          <label htmlFor="fondo" className="mb-1.5 block text-[13px] font-medium text-tinta-suave">
            Fondo inicial
          </label>

          <input
            id="fondo"
            inputMode="numeric"
            value={pesos}
            onChange={(e) => setPesos(e.target.value.replace(/[^\d]/g, ''))}
            placeholder="0"
            autoFocus
            className="num w-full rounded-lg border border-borde bg-papel px-3 py-3 text-right
                       text-[22px] outline-none focus:border-verde"
          />

          <p className="mt-1.5 text-[12.5px] text-tinta-tenue">
            Contalo antes de escribirlo: es la base con la que después se compara el arqueo.
          </p>
        </div>

        {error && (
          <p className="flex items-start gap-2 rounded-lg bg-rojo/10 px-3 py-2.5 text-[13px] text-rojo">
            <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
            {error}
          </p>
        )}

      </div>
    </Modal>
  )
}

